<div class="example-container">
  <h3>{{'Table management'}}</h3>
  <form [formGroup]="tableContentGroup">
    <mat-form-field appearance="fill">
      <mat-label>{{'Table management' | translate}}</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                formControlName="tableContent"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5" required></textarea>
    </mat-form-field>
    <p style="font-size: 12px">
      • separate tables by one space
    </p>
    <p style="font-size: 12px">• (A2) - mark table as life stamp</p>
  </form>
  <mat-dialog-actions align="center">
    <button mat-button mat-dialog-close>{{'Cancel' | translate}}</button>
    <button mat-button [disabled]="tableContentGroup.invalid" (click)="saveListOfTables()">{{'Save table'}}</button>
  </mat-dialog-actions>
</div>
